export type ThemeMode = 'light' | 'dark';
export type ThemeColor = 'blue' | 'indigo' | 'violet' | 'purple' | 'fuchsia' | 'pink' | 'rose' | 'red' | 'orange' | 'amber' | 'yellow' | 'lime' | 'green' | 'emerald' | 'teal' | 'cyan' | 'sky' | 'gray';

export interface ThemeOptions {
  mode: ThemeMode;
  color: ThemeColor;
}

const defaultTheme: ThemeOptions = {
  mode: 'light',
  color: 'gray',
};

const themeColors: ThemeColor[] = [
  'blue', 'indigo', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'red', 'orange', 'amber',
  'yellow', 'lime', 'green', 'emerald', 'teal', 'cyan', 'sky', 'gray',
];

export function resolveInitialTheme(savedTheme: string | null, prefersDark: boolean): ThemeOptions {
  const fallback: ThemeOptions = { ...defaultTheme, mode: prefersDark ? 'dark' : 'light' };
  if (!savedTheme) return fallback;

  try {
    const stored = JSON.parse(savedTheme) as Partial<ThemeOptions> | null;
    if (!stored || typeof stored !== 'object') return fallback;
    return {
      mode: stored.mode === 'dark' || stored.mode === 'light' ? stored.mode : fallback.mode,
      color: typeof stored.color === 'string' && themeColors.includes(stored.color as ThemeColor)
        ? stored.color as ThemeColor
        : fallback.color,
    };
  } catch {
    return fallback;
  }
}
